import * as request from '@/utils/request'

/**
 * 列表
 * @param data
 * @returns {Promise}
 */
export function productIngredientList(data) {
  return request.post('/product_ingredient/list', data)
}

/**
 * 保存
 * @param data
 * @returns {*}
 */
export function productIngredientSave(data) {
  return request.post('/product_ingredient/store', data)
}

/**
 * 删除
 * @param data
 * @returns {*}
 */
export function productIngredientDelete(data) {
  return request.post('/product_ingredient/delete', data)
}

/**
 *
 * @param data
 * @return {Promise}
 */
export function productIngredientReset(data) {
  return request.post('/product_ingredient/reset', data)
}
